import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PubnubService } from '../services/Pubnub.service';
import { ActivatedRoute } from '@angular/router';
import { Map, getInstance, UserData, UserType } from 'nextnavsdk';
import { firefighterData, policeData, emsData, securityData, e911CallerData } from '../../assets/data';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { filter, tap } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-deckgl-mapbox',
  templateUrl: './deckgl-mapbox.component.html',
  styleUrls: ['./deckgl-mapbox.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DeckglMapboxComponent implements OnInit {
  currentApplicationVersion = require('../../../package.json').version;
  uid: string;
  channelId: string;
  centreLat: any;
  centreLong: any;
  environment = environment;
  userLat: any;
  userLong: any;
  userHat: any;

  constructor(private http: HttpClient, private route: ActivatedRoute, private pubnub: PubnubService) {
    this.uid = this.route.snapshot.queryParams['uid'];
    this.channelId = this.route.snapshot.queryParams['channelId'] || this.route.snapshot.queryParams['channelid'];
    this.centreLat = this.route.snapshot.queryParams['centrelat'] || this.route.snapshot.queryParams['centreLat'];
    this.centreLong = this.route.snapshot.queryParams['centrelong'] || this.route.snapshot.queryParams['centreLong'];
    this.userLat = this.route.snapshot.queryParams['userlat'] || this.route.snapshot.queryParams['userLat'];
    this.userLong = this.route.snapshot.queryParams['userlong'] || this.route.snapshot.queryParams['userLong'];
    this.userHat = this.route.snapshot.queryParams['userhat'] || this.route.snapshot.queryParams['userHat'];
    if (this.userHat) {
      let regex = /(m|ft)$/;
      if (regex.test(this.userHat))
        this.userHat = this.userHat.split(regex)[1] == 'ft' ? this.userHat.split(regex)[0] * 0.3048 : this.userHat.split(regex)[0];

    }
    else {
      this.userHat = 1;
    }
  }
  svgToDataURL(svg: any) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  }
  createSVGIconWithText(text: any) {
    if (text == "")
      return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="#ffffff" stroke="#5EB2E1" stroke-width="1"/>
<circle cx="12" cy="12" r="8" fill="#ff0000" stroke="#ff0000" stroke-width="1"/>
</svg>
`;
    else return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" fill="rgb(255, 255, 255)" stroke="black" stroke-width="1"/>
<text x="5" y="16" fill="black" font-weight="bold" font-size="9" font-family="Verdana">` + text + `</text>
</svg>
`;
  }
  ngOnInit(): void {
    let defaultLat = 37.79131;
    let defaultLng = -122.41020;
    let firstLoad = true;
    var _this = this;
    let nextnavMap: any;
    // var pinnacleInterface = getInstance(CryptoJS.AES.decrypt(this.environment.API_KEY, '3DApp').toString(CryptoJS.enc.Utf8));
    var pinnacleInterface = getInstance('f5CWhIHdcN5EjXhLVUOmM9AeBihSQeXr8DHuLfjf');
    pinnacleInterface.on('load', function (event: any) {
      nextnavMap = new Map('container', {
        mapOptions: {
          //center: [0, 1],
          zoom: 18
        }
      });
    });

    if (_this.channelId) {
      _this.pubnub.showCasePubnumInstantiateAndSubscribe(environment.pubkey, environment.subkey, _this.channelId, _this.uid ? _this.uid : 'Test');
      let position: any = {};
      _this.pubnub.addObserver(_this.channelId).subscribe(async (obj: any) => {
        console.log(obj);
        console.log(obj.message.location2d.latitude + ", " + obj.message.location2d.longitude + ", " + obj.message.heightAboveTerrain)
        if (pinnacleInterface.isLoaded) {
          if (firstLoad) {
            if (_this.centreLat && _this.centreLong)
              pinnacleInterface.setMapLocation({ lat: Number(_this.centreLat), lng: Number(_this.centreLong), zoom: 18, orientation: 0 });
            else
              if (obj.message) if (obj.message.location2d) if (obj.message.location2d.latitude && obj.message.location2d.longitude)
                pinnacleInterface.setMapLocation({ lat: Number(obj.message.location2d.latitude), lng: Number(obj.message.location2d.longitude), zoom: 18, orientation: 0 });
            firstLoad = false;
          }
          let userType = null;
          if (obj.message && obj.message.type)
            userType = obj.message.type;
          if (obj.publisher) {
            let img = null;
            let userTypeEnum = null;
            if (userType == 2) {
              img = './assets/police.png';
              userTypeEnum = UserType.POLICE;
            }
            else if (userType == 1) {
              img = './assets/firefighter.png';
              userTypeEnum = UserType.FIREFIGHTER;
            }
            else if (userType == 3) {
              img = './assets/ems.png';
              userTypeEnum = UserType.EMS;
            }
            else if (userType == 4) {
              img = './assets/security.png';
              userTypeEnum = UserType.SECURITY;
            }
            else if (userType == 5) {
              img = './assets/e911caller.png';//_this.svgToDataURL(_this.createSVGIconWithText(""));
              userTypeEnum = UserType.E911USER;
            }
            else {
              img = './assets/man.png';
              userTypeEnum = UserType.OTHER;
            }
            if (!position[obj.publisher]) {
              position[obj.publisher] = new UserData({
                id: obj.publisher,
                userType: userTypeEnum, imgPath: img, lat: obj.message.location2d.latitude,
                lng: obj.message.location2d.longitude,
                hat: obj.message.heightAboveTerrain,
                // efl: ((obj.message.estimatedFloorValue == 0 || obj.message.estimatedFloorValue) ? obj.message.estimatedFloorValue : Math.round(obj.message.heightAboveTerrain / 3)),
                // hat: obj.message.isLocationUserPinned ? 1 : obj.message.heightAboveTerrain,
                // efl: obj.message.isLocationUserPinned ? 0 : ((obj.message.estimatedFloorValue == 0 || obj.message.estimatedFloorValue) ? obj.message.estimatedFloorValue : Math.round(obj.message.heightAboveTerrain / 3)),
                firstName: obj.message.firstName,
                lastName: obj.message.lastName,
                timestamp: obj.message.timestamp
              });
              pinnacleInterface.addUser(position[obj.publisher]);
            }

            if (position[obj.publisher]) {
              if (obj.message && obj.message.location2d && obj.message.location2d.latitude && obj.message.location2d.longitude) {
                obj.message.heightAboveTerrain = obj.message.heightAboveTerrain ? obj.message.heightAboveTerrain : 0;
                if (isFinite(obj.message.location2d.latitude) && Math.abs(obj.message.location2d.latitude) <= 90 && Math.abs(obj.message.location2d.longitude) <= 180 && Math.abs(obj.message.location2d.longitude) <= 180 && isFinite(obj.message.heightAboveTerrain)) {
                  pinnacleInterface.updateUserLocation({
                    id: obj.publisher,
                    lat: obj.message.location2d.latitude,
                    lng: obj.message.location2d.longitude,
                    // hat: obj.message.isLocationUserPinned ? 1 : obj.message.heightAboveTerrain,
                    // efl: obj.message.isLocationUserPinned ? 0 : ((obj.message.estimatedFloorValue == 0 || obj.message.estimatedFloorValue) ? obj.message.estimatedFloorValue : Math.round(obj.message.heightAboveTerrain / 3)),
                    hat: obj.message.heightAboveTerrain,
                    // efl: ((obj.message.estimatedFloorValue == 0 || obj.message.estimatedFloorValue) ? obj.message.estimatedFloorValue : Math.round(obj.message.heightAboveTerrain / 3)),
                    userType: userTypeEnum,
                    imgPath: img,
                    // firstName: obj.message.firstName,
                    // lastName: obj.message.lastName,
                    timestamp: obj.message.timestamp
                  });
                }
              }
            }
          }
          // console.log(obj.timeout);
          if (obj.timeout) {
            if (position && position[obj.uuid]) {
              pinnacleInterface.removeUser(obj.uuid);
              delete position[obj.uuid];
            }
          }
        }
      });
    }
    else if (_this.userLat && _this.userLong) {
      if (firstLoad) {
        pinnacleInterface.on('load', async function (event: any) {
          pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : Number(_this.userLat), lng: _this.centreLong ? Number(_this.centreLong) : Number(_this.userLong), zoom: 18, orientation: 200 });
          nextnavMap.on('load', async function (event: any) {
            pinnacleInterface.addUser(new UserData({
              id: 'id',
              userType: UserType.OTHER,
              imgPath: './assets/man.png',
              lat: Number(_this.userLat),
              lng: Number(_this.userLong),
              hat: Number(_this.userHat ? _this.userHat : 1),
              // efl: Math.round(_this.userHat / 3),
              firstName: "Guest", lastName: "User"
            }));
          });
        });
        firstLoad = false;
      }
    }
    setTimeout(function () {
      if (firstLoad) {
        if (pinnacleInterface.isLoaded)
          pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : defaultLat, lng: _this.centreLong ? Number(_this.centreLong) : defaultLng, zoom: 18, orientation: 0 });
        else
          pinnacleInterface.on('load', function (event: any) {
            pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : defaultLat, lng: _this.centreLong ? Number(_this.centreLong) : defaultLng, zoom: 18, orientation: 0 });
          });
        firstLoad = false;
      }
    }, 5000);

    // var UserTypes = UserType;
    //timeout to let the pubnum instance initize with route params from showcase component
    // _this.route.queryParams
    //   .pipe(
    //     filter(queryParams => Object.keys(queryParams).length === 0)
    //   )
    //   .subscribe(() => {
    //     pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : defaultLat, lng: _this.centreLong ? Number(_this.centreLong) : defaultLng, zoom: 18, orientation: 200 });
    // pinnacleInterface.addUser(new UserData({
    //   id: 'Police',
    //   userType: UserType.POLICE,
    //   imgPath: '../../assets/police.png',
    //   lat: 37.79185,
    //   lng: -122.41060,
    //   hat: 1,
    //   hae: null,
    //   efl: null,
    //   firstName: 'David',
    //   lastName: 'Gary',
    // }));
    // // Adding Firefighter user to nextnav map
    // pinnacleInterface.addUser(new UserData({
    //   id: 'Fire',
    //   userType: UserType.FIREFIGHTER,
    //   imgPath: '../../assets/firefighter.png',
    //   lat: 37.79185,
    //   lng: -122.41063,
    //   hat: 1,
    //   hae: null,
    //   efl: null,
    //   firstName: 'Jack',
    //   lastName: 'Wyatt'
    // }));
    // // Adding security user to nextnav map
    // pinnacleInterface.addUser(new UserData({
    //   id: 'Security',
    //   userType: UserType.SECURITY,
    //   imgPath: '../../assets/security.png',
    //   lat: 37.79174,
    //   lng: -122.41083,
    //   hat: 1,
    //   hae: null,
    //   efl: null,
    //   firstName: 'Katie', lastName: 'Belle'
    // }));
    // //Adding EMS user to nextnav map
    // pinnacleInterface.addUser(new UserData({
    //   id: 'EMS',
    //   userType: UserType.EMS,
    //   imgPath: '../../assets/ems.png',
    //   lat: 37.79189,
    //   lng: -122.41061,
    //   hat: 1,
    //   hae: null,
    //   efl: null,
    //   firstName: 'Roy',
    //   lastName: 'Lee'
    // }));
    // // Adding emergency user to nextnav map
    // pinnacleInterface.addUser(new UserData({
    //   id: 'Caller',
    //   userType: UserType.E911USER,
    //   imgPath: '../../assets/e911caller.png',
    //   lat: 37.79151,
    //   lng: -122.41046,
    //   hat: 60,
    //   hae: null,
    //   efl: null,
    //   firstName: 'Mary',
    //   lastName: 'Kate'
    // }));

    // // Counters for users data movement
    // let e911CallerCounter = 0;
    // let copCounter = 0;
    // let ffCounter = 0;
    // let u1Counter = 0;
    // let u2Counter = 0;
    // // updating users location for every 0.5 sec with sample data
    // let policeInterval = setInterval(function () {
    //   // Updating police user location on nextnav map
    //   pinnacleInterface.updateUserLocation({
    //     id: policeData[copCounter].id,
    //     lat: policeData[copCounter].lat,
    //     lng: policeData[copCounter].lng,
    //     hat: policeData[copCounter].hat,
    //     efl: policeData[copCounter].efl,
    //     firstName: policeData[copCounter].firstName,
    //     lastName: policeData[copCounter].lastName
    //   });
    //   copCounter++;
    //   if (copCounter >= policeData.length - 1) {
    //     copCounter = 0;
    //     // clearInterval(policeInterval);
    //   }
    // }, 750);
    // let ffInterval = setInterval(function () {
    //   //Updating firefighter user location on nextnav map
    //   pinnacleInterface.updateUserLocation({
    //     id: firefighterData[ffCounter].id,
    //     lat: firefighterData[ffCounter].lat,
    //     lng: firefighterData[ffCounter].lng,
    //     hat: firefighterData[ffCounter].hat,
    //     efl: firefighterData[ffCounter].efl,
    //     firstName: firefighterData[ffCounter].firstName,
    //     lastName: firefighterData[ffCounter].lastName
    //   });
    //   ffCounter++;
    //   if (ffCounter >= firefighterData.length - 1) {
    //     ffCounter = 0;
    //     // clearInterval(ffInterval);
    //   }
    // }, 750);
    // let u1Interval = setInterval(function () {
    //   // Updating security user location on nextnav map
    //   pinnacleInterface.updateUserLocation({
    //     id: securityData[u1Counter].id,
    //     lat: securityData[u1Counter].lat,
    //     lng: securityData[u1Counter].lng,
    //     hat: securityData[u1Counter].hat,
    //     efl: securityData[u1Counter].efl,
    //     firstName: securityData[u1Counter].firstName,
    //     lastName: securityData[u1Counter].lastName
    //   });
    //   u1Counter++;
    //   if (u1Counter >= securityData.length - 1) {
    //     u1Counter = 0;
    //     // clearInterval(u1Interval);
    //   }
    // }, 750);
    // let u2Interval = setInterval(function () {
    //   // Updating EMS user location on nextnav map
    //   pinnacleInterface.updateUserLocation({
    //     id: emsData[u2Counter].id,
    //     lat: emsData[u2Counter].lat,
    //     lng: emsData[u2Counter].lng,
    //     hat: emsData[u2Counter].hat,
    //     efl: emsData[u2Counter].efl,
    //     firstName: emsData[u2Counter].firstName,
    //     lastName: emsData[u2Counter].lastName
    //   });
    //   u2Counter++;
    //   if (u2Counter >= emsData.length - 1) {
    //     u2Counter = 0
    //     // clearInterval(u2Interval);
    //   }
    // }, 750);
    // let e911Interval = setInterval(function () {
    //   // Updating emergency user location on nextnav map
    //   pinnacleInterface.updateUserLocation({
    //     id: e911CallerData[e911CallerCounter].id,
    //     lat: e911CallerData[e911CallerCounter].lat,
    //     lng: e911CallerData[e911CallerCounter].lng,
    //     hat: e911CallerData[e911CallerCounter].hat,
    //     efl: e911CallerData[e911CallerCounter].efl,
    //     firstName: e911CallerData[e911CallerCounter].firstName,
    //     lastName: e911CallerData[e911CallerCounter].lastName
    //   });
    //   e911CallerCounter++;
    //   if (e911CallerCounter >= e911CallerData.length - 1) {
    //     e911CallerCounter = 0;
    //     // clearInterval(e911Interval);
    //   }
    // }, 750);

    // });


  }
  // async getEFlValue(x: any, y: any, z: any, zUncertainty: any) {
  // const url = 'https://pinnacle.nextnavapis.io/v2/hae-to-hat';
  // const headers = new HttpHeaders({
  //   'x-api-key': '',
  //   'Content-Type': 'application/json',
  // });

  // const requestBody = {
  //   xyLocation: {
  //     latitude: x,
  //     longitude: y,
  //     xyUncertainty: 25,
  //     xyConfidence: 'CONF68',
  //   },
  //   zInput: {
  //     zValue: z,
  //     zUncertainty: zUncertainty,
  //     zType: 'HAT',
  //     zConfidence: 'CONF68',
  //   },
  // };

  // try {
  //   const response: any = await this.http.post(url, requestBody, { headers }).toPromise();
  //   if (response.status == 'N200')
  //     return response.efl.estimateFloorNumber;
  //   else
  //     return Number.NaN;
  // } catch (error) {
  //   console.error('Error:', error);
  //   throw error;
  // }
  // }
}